<!--
 * @Author: tiandi
 * @Date: 2022-01-19 16:01:07
 * @LastEditTime: 2024-08-01 14:07:25
 * @LastEditors: dyl
 * @Description: 上级检查整改
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/index.vue
-->
<template>
  <section>
    <wn-template
      :list-query.sync="listQuery"
      :filter-query-list="filterQueryList"
      :search-key-info="searchKeyInfo"
      :show-table-check-list.sync="showTableCheckList"
      @fetchData="GetZGList"
    >
      <div class="flex mt-10" style="height: 50px; position: relative">
        <w-tabs
          v-if="xfwdList.length > 1"
          v-model="wdType"
          type="card"
          class="check-result-tabs"
          @tab-click="changeType"
        >
          <w-tab-pane
            v-for="item in xfwdList"
            :key="item.XFWD + ''"
            :label="item.XFWDMC"
            :name="item.XFWD + ''"
          ></w-tab-pane>
        </w-tabs>

        <div
          slot="funBtn"
          class="mt-10 tab-btn"
          style="width: 50%; display: inline-block"
        >
          <more-cols
            ref="moreCols"
            class="mr-10 wn-fr"
            :show-table-col-list="tableColumns"
            :show-table-check-list.sync="showTableCheckList"
            @getLastCheckList="getLastCheckList"
          ></more-cols>
          <w-button
            class="wn-fr mr-8"
            style="margin-left: 8px"
            size="small"
            @click="printList"
          >
            打印
          </w-button>
          <w-dropdown
            class="wn-fr"
            trigger="click"
            style="margin-left: 10px"
            size="small"
          >
            <w-button size="small" type="primary">
              导出
              <i class="w-icon-arrow-bottom"></i>
            </w-button>
            <w-dropdown-menu slot="dropdown-menu">
              <w-dropdown-menu-item @click="exportFile('EXCEL')"
                >EXCEL</w-dropdown-menu-item
              >
              <w-dropdown-menu-item @click="exportFile('PDF')"
                >PDF</w-dropdown-menu-item
              >
            </w-dropdown-menu>
          </w-dropdown>
          <w-button
            v-if="isOpenMulti"
            class="wn-fr ml-10"
            size="small"
            @click="mulZG()"
          >
            批量整改
          </w-button>
          <w-checkbox
            v-if="isShowOnlyMe"
            v-model="isOnlyMe"
            class="wn-fr ml-10 mt-5"
            @change="GetZGList"
          >
            只看我的
          </w-checkbox>
        </div>
      </div>
      <w-table
        ref="singleSelect"
        v-win-loading="loading"
        :data="tableData"
        highlight-current-row
        border
        style="width: 100%"
        class="mt-8"
        stripe
        :height="tableHeight"
        :span-method="mergeSpanMethod"
        :header-cell-style="{ 'text-align': 'center' }"
        @current-change="handleCurrentChange"
        @selection-change="handleSelectionChange"
      >
        <w-table-column
          v-if="isOpenMulti"
          type="selection"
          align="center"
          width="50"
          :selectable="selected"
        />
        <template v-for="(co, index) in newTableList">
          <w-table-column
            v-if="co.key != 'fileList'"
            :key="index"
            :label="co.name"
            :prop="co.key"
            :width="co.width"
            :min-width="co.minWidth"
            :align="co.align"
          >
            <template slot-scope="scope">
              <span v-if="co.key == 'ZGZTMC'">
                <span
                  v-if="scope.row.IsIgnore"
                  style="color: red"
                  type="info"
                  :plain="false"
                  size="mini"
                  >已忽略
                </span>
                <span
                  v-else-if="scope.row.XFZT == '1'"
                  type="info"
                  :plain="false"
                  size="mini"
                  >无需整改
                </span>
                <w-tag
                  v-else-if="scope.row.ZGZT == 0"
                  type="warning"
                  :plain="false"
                  size="small"
                  >待整改
                </w-tag>
                <w-tag
                  v-else-if="scope.row.ZGZT == 1"
                  type="info"
                  :plain="false"
                  size="small"
                  >整改中
                </w-tag>
                <w-tag
                  v-else
                  type="success"
                  :plain="false"
                  style="background-color: #5eb95e"
                  size="small"
                  >{{ scope.row.ZGZT == 2 ? '待评价' : '已评价' }}
                </w-tag>
              </span>
              <span
                v-else-if="
                  co.key == 'GJXGMC' ||
                  co.key == 'GZPJ' ||
                  co.key == 'PJRMC' ||
                  co.key == 'PJSJ'
                "
              >
                <w-row
                  v-for="(item, idx) in scope.row.pjList"
                  :key="idx"
                  class="table-inner-row"
                >
                  <w-tooltip
                    v-if="
                      co.key == 'GZPJ' &&
                      item[co.key] &&
                      item[co.key].length > 15
                    "
                    width="200px"
                    theme="dark"
                    :content="item[co.key]"
                    placement="top-start"
                  >
                    <div
                      slot="reference"
                      class="tooltip-reference table-inner-row-text"
                    >
                      {{ item[co.key].slice(0, 15) + '...' }}
                    </div>
                  </w-tooltip>
                  <span v-else>
                    {{ item[co.key] }}
                  </span>
                </w-row>
              </span>
              <span v-else-if="co.key == 'IgnoreFileList'">
                <w-link
                  v-if="
                    scope.row.IgnoreFileList &&
                    scope.row.IgnoreFileList.length > 0
                  "
                  :underline="true"
                  type="primary"
                  @click="viewIgnoreFile(scope.row, '')"
                >
                  忽略附件({{ scope.row.IgnoreFileList.length }})
                </w-link>
              </span>
              <span v-else-if="co.key == 'ZgFileList'">
                <w-link
                  v-if="scope.row.ZgFileList && scope.row.ZgFileList.length > 0"
                  :underline="true"
                  type="primary"
                  @click="viewIgnoreFile(scope.row, 'zg')"
                >
                  整改附件({{ scope.row.ZgFileList.length }})
                </w-link>
              </span>
              <span v-else>
                <w-tooltip
                  v-if="scope.row[co.key] && scope.row[co.key].length > 15"
                  width="200px"
                  theme="dark"
                  :content="scope.row[co.key]"
                >
                  <div
                    slot="reference"
                    class="tooltip-reference table-inner-row-text"
                  >
                    {{ scope.row[co.key] }}
                  </div>
                </w-tooltip>
                <span v-else>
                  {{ scope.row[co.key] }}
                </span>
              </span>
            </template>
          </w-table-column>
          <w-table-column
            v-else
            :key="co.key"
            :label="co.name"
            :width="co.width"
            :align="co.align"
          >
            <template slot-scope="scope">
              <i
                v-if="scope.row['fileList'] && scope.row['fileList'].length > 0"
                class="w-icon-picture"
                style="size: 48px; color: rgb(12, 147, 177); cursor: pointer"
                @click="showImg(scope.row)"
              ></i>
            </template>
          </w-table-column>
        </template>
        <w-table-column label="操作" width="240" align="center" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.XFZT == '0'">
              <!-- ZGZT状态 0待整改 1整改中 2待评价 3已评价-->
              <w-button
                v-if="scope.row.SFDJ == 1"
                type="text"
                :disabled="!scope.row.isCanSQ || scope.row.IsIgnore"
                class="red-botton"
                @click="toSQ(scope.row)"
              >
                整改申请
              </w-button>
              <template v-else>
                <w-button
                  type="text"
                  :disabled="scope.row.ZGZT > 1 || scope.row.IsIgnore"
                  @click="toDetail(scope.row, 0)"
                >
                  整改
                </w-button>
                <w-button
                  v-if="IscanIgnore"
                  type="text"
                  :disabled="
                    scope.row.ZGZT > 1 ||
                    scope.row.IsIgnore ||
                    scope.row.SFBXZG == 1
                  "
                  @click="ignore(scope.row)"
                >
                  忽略
                </w-button>
                <w-button
                  v-if="IscanIgnore"
                  type="text"
                  :disabled="scope.row.ZGZT > 1 || !scope.row.IsIgnore"
                  @click="canCelIgnore(scope.row)"
                >
                  撤销忽略
                </w-button>
              </template>

              <w-button
                type="text"
                :disabled="scope.row.SFDJ == 1 || scope.row.ZGZT != 2"
                @click="rollBack(scope.row)"
              >
                撤销整改
              </w-button>
              <w-button type="text" @click="onDetail(scope.row, 1)">
                检查详情
              </w-button>
              <w-button
                v-if="needZP"
                type="text"
                :disabled="
                  scope.row.ZGZT == 3 ||
                  scope.row.ZGZT == 0 ||
                  scope.row.IsIgnore
                "
                @click="toDetail(scope.row, 1)"
              >
                自评
              </w-button>
              <w-dropdown
                style="margin-left: 10px; transform: translateY(-3px)"
                popper-width="80px"
                @toggle="toggle"
              >
                更多
                <svg
                  :class="isShow ? 'is-active' : ''"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.75 5.7998L7.99274 10.0425L12.2361 5.79921"
                    stroke="black"
                    stroke-opacity="1"
                    stroke-width="1.5"
                  />
                </svg>
                <w-dropdown-menu slot="dropdown-menu">
                  <w-dropdown-menu-item>
                    <w-button
                      type="text"
                      :disabled="scope.row.ZGZT == 0"
                      @click="print(scope.row.WTXH)"
                    >
                      打印
                    </w-button></w-dropdown-menu-item
                  >
                </w-dropdown-menu>
              </w-dropdown>
            </template>
            <template v-else>
              <w-status type="error" common size="small">及时整改</w-status>
            </template>
          </template>
        </w-table-column>
      </w-table>
    </wn-template>
  </section>
</template>

<script>
import ApplyDialog from '@/common/components/Dialog/ApplyDialog.vue'
import PdfDialog from '@/common/components/Dialog/pdfDialog.vue'
import MoreCols from '@/common/components/MoreCols'
import WnTemplate from '@/common/components/WnTemplate'
import { pageSizes } from '@/common/settings/pageSettings'
import { getTableCheckColumns } from '@/common/utils'
import { DownFile, Print } from '@/common/utils/download'
import { toArray } from '@/common/utils/table.common.js'
import { mapGetters } from 'vuex'
import { GetJHJCBDList, GetZGList, GetZZjgByZkjbAndUser } from './_api/index'
import imgView from './_components/imgView.vue'
import QcRectificationDetail from './_components/QcRectificationDetail.vue'
import { GetXTMJList } from '@/apps/modules/common/_api/index'
import IgnoreZG from './_components/IgnoreZG.vue'
import TaskDetailDialog from '../../qc-check/check/_components/dialog/TaskDetailDialog.vue'
import { isArray } from 'xe-utils'

export default {
  name: 'QcRectification',
  components: { WnTemplate, MoreCols, imgView, TaskDetailDialog },
  data() {
    return {
      isShow: false,
      applyData: {},
      UserInfo: {},
      wdType: null,
      pageSizes: pageSizes,
      PageSize: 20,
      PageIndex: 1,
      tableData: [],
      showTableCheckList: [],
      newTableList: [],
      tableColumns: [
        {
          name: '整改状态',
          key: 'ZGZTMC',
          align: 'center',
          width: '100',
          keepChoosing: true,
          checked: true
        },
        {
          name: '问题来源',
          key: 'ZKJBMC',
          align: 'left',
          width: '120',
          keepChoosing: true,
          checked: true
        },
        {
          name: '受检科室',
          key: 'JCKSMC',
          align: 'left',
          width: '120',
          keepChoosing: true,
          checked: true
        },
        {
          name: '督查时间',
          key: 'JCSJ',
          align: 'left',
          width: '120',
          keepChoosing: true,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'left',
          width: '240',
          keepChoosing: true,
          checked: true
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'KFFZ',
          align: 'right',
          width: '120',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查者',
          key: 'JCZ',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '其他检查者',
          key: 'QTJCZ',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '结果提交人',
          key: 'JGTJR',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '整改类型',
          key: 'ZGLX',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '下发人',
          key: 'XFR',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '下发时间',
          key: 'XFSH',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '被查人',
          key: 'BJCZMC',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: true
        },
        {
          name: '接收人',
          key: 'JSR_MC',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '责任人',
          key: 'ZRRMC',
          align: 'left',
          width: '120',
          keepChoosing: false,
          checked: true
        },
        {
          name: '备注',
          key: 'MEMO',
          align: 'left',
          width: '160',
          keepChoosing: false,
          checked: false
        },
        {
          name: '整改要点',
          key: 'ZGYD',
          align: 'left',
          width: '160',
          keepChoosing: false,
          checked: true
        },
        {
          name: '原因分析',
          key: 'YYFX',
          align: 'left',
          width: '120',
          keepChoosing: true,
          checked: true
        },
        {
          name: '整改措施',
          key: 'ZGCS',
          align: 'left',
          width: '160',
          keepChoosing: true,
          checked: true
        },
        {
          name: '整改人',
          key: 'ZGR_MC',
          align: 'left',
          width: '120',
          keepChoosing: true,
          checked: true
        },
        {
          name: '整改时间',
          key: 'ZGSJ',
          align: 'left',
          width: '120',
          keepChoosing: true,
          checked: true
        },
        {
          name: '评价内容',
          key: 'GZPJ',
          width: '200',
          align: 'left',
          keepChoosing: false,
          checked: false
        },
        {
          name: '评价人',
          key: 'PJRMC',
          width: '140',
          align: 'left',
          keepChoosing: false,
          checked: false
        },
        {
          name: '评价时间',
          key: 'PJSJ',
          width: '120',
          align: 'left',
          keepChoosing: false,
          checked: false
        },
        {
          name: '检查附件',
          key: 'fileList',
          align: 'center',
          width: '100',
          checked: true
        },
        {
          name: '整改附件',
          key: 'ZgFileList',
          align: 'center',
          width: '100',
          checked: true
        },
        {
          name: '忽略说明',
          key: 'HLSM',
          align: 'center',
          width: '120',
          checked: true
        },
        {
          name: '忽略附件',
          key: 'IgnoreFileList',
          align: 'center',
          width: '120',
          checked: true
        }
      ],
      defaultColumns: [], //用作保存原始列，方便切换tab
      currentRow: null,
      listQuery: {
        PageIndex: 1,
        PageSize: 15,
        total: 0,
        StartTime: '',
        EndTime: '',
        Zkjb: '',
        Jcfw: '',
        Bddms: '',
        XMWD: '20',
        ZGLX: ''
      },
      filterQueryList: [
        {
          conditionCode: 'Zkjb', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '问题来源', // 更多筛选-名称
          keepChoosing: false, // 更多筛选-是否可取消选择
          conditionType: 'DYNAMIC_SELECTION', // 查询条件字段类型
          isMulti: true,
          hide: false,
          clearable: true,
          dataList: [],
          callback: (val, code) => {
            if (val && isArray(val)) {
              this.listQuery.Zkjb = val.join(',')
            } else {
              this.listQuery.Zkjb = val
              if (this.status1095 == '2' && val == '1003') {
                this.isOpenMulti = true
              } else {
                this.isOpenMulti = this.status1095 == '1'
              }
            }
            this.GetZGList()
          }
        },
        {
          conditionCode: 'StartTime,EndTime', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '督查周期', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'MONTH_QUARTER_HALF_YEAR_SELECT', // 查询条件字段类型
          hide: false,
          dataList: []
        },
        {
          conditionCode: 'Jcfw', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '受检科室', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'POPOVER_SELECT', // 查询条件字段类型
          isMulti: true,
          flexSelect: true,
          hide: false,
          clearable: true,
          dataList: [],
          callback: (val, code) => {
            this.listQuery.Jcfw = val
            this.GetZGList()
          }
        },
        {
          conditionCode: 'Bddms', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '检查表单', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'POPOVER_JCBD_SELECT', // 查询条件字段类型
          isMulti: true,
          Bhty: true,
          flexSelect: true,
          hide: false,
          clearable: true,
          dataList: [],
          callback: (val, code) => {
            this.listQuery.Bddms = val
            this.GetZGList()
          }
        },
        {
          conditionCode: 'ZGZT', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '整改状态', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'DYNAMIC_SELECTION', // 查询条件字段类型
          isMulti: true,
          clearable: true,
          hide: false,
          dataList: [
            { selectionCode: '0', selectionName: '待整改' },
            { selectionCode: '1', selectionName: '整改中' },
            { selectionCode: '2', selectionName: '待评价' },
            { selectionCode: '3', selectionName: '已评价' },
            { selectionCode: '-1', selectionName: '已忽略' }
          ],
          callback: (val, code) => {
            if (val) {
              this.listQuery.ZGZT = val.join(',')
            }
            this.GetZGList()
          }
        },
        {
          conditionCode: 'ZGLX', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '整改类型', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'DYNAMIC_SELECTION', // 查询条件字段类型
          isMulti: true,
          clearable: true,
          hide: false,
          dataList: [
            { selectionCode: '0', selectionName: '书面整改' },
            { selectionCode: '1', selectionName: '及时整改' }
          ],
          callback: (val, code) => {
            if (val) {
              //全选时默认不全,兼容后台数据类型
              if (val.length > 1) {
                this.listQuery.ZGLX = ''
              } else {
                this.listQuery.ZGLX = val.join(',')
              }
            }
            this.GetZGList()
          }
        }
      ],
      searchKeyInfo: {
        name: '试卷名/创建人', // searchKey-名称
        onlySearch: true
      },
      isOnlyMe: true,
      isShowOnlyMe: false, // 1100参数如果开启就只能看自己的检查，这时候就没有这个开关的必要了
      xfwdList: [{ XFWD: '20', XFWDMC: '质量标准' }],
      loading: false,
      isOpenMulti: true, //是否开启批量整改
      status1095: '0',
      selectObj: [],
      dataArr1: [[]], //用于合并列
      rowSpanArr1: [[]], //用于合并列
      mergeColumn: [
        { colmunIndex: 0, condition: ['PLFXDM'] },
        { colmunIndex: 1, condition: ['PLFXDM'] },
        { colmunIndex: 2, condition: ['PLFXDM'] },
        { colmunIndex: 3, condition: ['PLFXDM'] },
        { colmunIndex: 4, condition: ['PLFXDM'] },
        { colmunIndex: 5, condition: ['PLFXDM'] },
        { colmunIndex: 6, condition: ['PLFXDM'] }
      ],
      needZP: false, //是否需要自评
      tableHeight: 'calc(100% - 10px)',
      showImgList: [],
      showImgFLag: false,
      IscanIgnore: false,
      dictObj: {}
    }
  },
  computed: {
    ...mapGetters(['systemParam'])
  },
  watch: {
    showTableCheckList(val) {
      this.handleAddNewList()
      this.$nextTick(() => {
        if (this.$refs.singleSelect) {
          this.$refs.singleSelect.doLayout()
        }
      })
    }
  },
  created() {
    // 获取字典信息
    this.dictObj = JSON.parse(localStorage.getItem('dict'))

    this.newTableList = this.tableColumns
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.defaultColumns = this.tableColumns
    this.wdType = this.systemParam.wdType
    this.changeType({ name: this.wdType })
    this.listQuery.XFWD = this.systemParam.wdType
    this.listQuery.ZGLX = '0'
    this.getXtmj()
    this.getZKJB()
    this.getNeedZP()
    this.GetXFWDList()
    this.getZZjg()
    this.showTableCheckList = getTableCheckColumns(
      'QcRectification',
      this.tableColumns
    )
  },
  mounted() {
    this.GetSxkzList()
    if (localStorage.getItem('queryTime')) {
      let obj1 = JSON.parse(localStorage.getItem('queryTime'))
      this.listQuery.StartTime = obj1.StartTime
      this.listQuery.EndTime = obj1.EndTime
    }
    if (localStorage.getItem('querySingleItems')) {
      let obj2 = JSON.parse(localStorage.getItem('querySingleItems'))
      if (obj2.zkjb && obj2.ORGID) {
        this.filterQueryList[0].default = obj2.zkjb
      }
    }
    this.listQuery.ZGZT = '0,1'
  },
  beforeDestroy() {
    this.handleChangeQuery()
  },
  methods: {
    toggle(value) {
      this.isShow = value
    },
    handleChangeQuery() {
      let obj = JSON.parse(localStorage.getItem('querySingleItems'))
      // 多选质控级别不保存
      // if (this.listQuery.Zkjb.indexOf(',') == -1) {
      //   localStorage.setItem(
      //     'querySingleItems',
      //     JSON.stringify({
      //       zkjb: this.listQuery.Zkjb.toString(),
      //       ORGID: obj.ORGID
      //     })
      //   )
      // }

      localStorage.setItem(
        'queryTime',
        JSON.stringify({
          StartTime: this.listQuery.StartTime,
          EndTime: this.listQuery.EndTime
        })
      )
    },
    GetSxkzList() {
      this.$requestApi('GetSxkzList', {}).then((res) => {
        if (res.success) {
          this.applyData = res.data.DataList.find((i) => i.CJDM == 'JCWTZG')
        } else {
          this.$msg(res.message)
        }
      })
    },
    getLastCheckList(val) {
      if (val.length > 0) {
        localStorage.setItem(
          'QcRectification',
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem('QcRectification')
      }
    },
    handleAddNewList() {
      this.newTableList = []
      this.tableColumns.forEach((item) => {
        if (this.showTableCheckList.some((val) => val.key == item.key)) {
          this.newTableList.push(item)
        }
      })
    },
    selected(row, index) {
      if (row.XFZT == '1' || row.ZGZT >= 2 || row.IsIgnore) {
        return false
      } else {
        return true
      }
    },
    // 获取下发维度
    GetXFWDList() {
      this.$requestApi('GetXFWDList').then((res) => {
        this.xfwdList = res.data
        // this.wdType = this.xfwdList[0].XFWD + ''
        if (this.xfwdList.length > 1) {
          this.tableHeight = 'calc(100% - 70px)'
        } else {
          this.tableHeight = 'calc(100% - 10px)'
        }
        this.listQuery.XFWD = this.xfwdList.find(
          (i) => i.XFWD == this.wdType
        ).XFWD
      })
    },
    // 查询是否需要自评
    getNeedZP() {
      let that = this
      this.$requestApi('GetXTMJList', { Mjdm: '1098' }).then((res) => {
        if (res.data) {
          if (res.data && res.data.length > 0) {
            that.needZP = res.data[0].JLZT == '1'
          }
        }
      })
    },
    getXtmj() {
      let that = this
      that
        .$requestApi('GetXTMJList', { Mjdm: '1095,1100,1227' })
        .then((res) => {
          if (res.success) {
            that.status1095 = res.data.find((m) => m.MJDM == 1095).JLZT
            if (that.status1095 == '0') {
              that.isOpenMulti = false
            }
            if (that.status1095 == '1') {
              that.isOpenMulti = true
            }
            if (that.status1095 == '2') {
              that.filterQueryList[0].isMulti = false
              that.filterQueryList[0].clearable = false
            }
            that.isShowOnlyMe = res.data.find((m) => m.MJDM == 1100).JLZT != '1'
            that.IscanIgnore = res.data.find((m) => m.MJDM == 1227)?.JLZT == '1'
          }
        })
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    handleSelectionChange(val) {
      this.selectObj = []
      let that = this
      // 处理合并列后的选择
      val.forEach((item) => {
        if (item.PLFXDM) {
          that.tableData.forEach((n) => {
            if (n.PLFXDM == item.PLFXDM) {
              this.selectObj.push(n)
            }
          })
        } else if (item.FXXH) {
          that.tableData.forEach((n) => {
            if (n.FXXH == item.FXXH) {
              this.selectObj.push(n)
            }
          })
        } else {
          this.selectObj.push(item)
        }
      })
    },
    // 查询条件-质控级别
    getZKJB() {
      const that = this
      this.$requestApi('GetXTMJList', { Mjlx: '001' }).then((res) => {
        if (res.success) {
          that.filterQueryList[0].dataList = res.data.map((m) => {
            return {
              selectionName: m.MJMC,
              selectionCode: m.MJDM.toString()
            }
          })
          if (
            !this.filterQueryList[0].dataList.find(
              (i) => i.selectionCode == this.filterQueryList[0].default
            )
          ) {
            this.filterQueryList[0].default = ''
          }
          if (res.data && res.data.length > 0) {
            that.listQuery.Zkjb = this.filterQueryList[0].default
              ? this.filterQueryList[0].default
              : res.data[0].MJDM

            // 这里做字典验证 (是否开启记忆)
            let isMemory = this.dictObj.find(
              (item) => item.code === 1232
            )?.isOpen
            // 如果没有开启记忆功能
            if (!isMemory) {
              let defaultZKLevel = this.dictObj
                .find((item) => item.code === 1143)
                .defaultValue.slice(-4)
              //该级别用户是否有权限操作
              let isPower = this.filterQueryList[0].dataList.find(
                (item) => item.selectionCode === defaultZKLevel
              )

              if (isPower) {
                this.listQuery.Zkjb = isPower.selectionCode
                this.filterQueryList[0].default = isPower.selectionCode
              }

              //获取本月的时间
              let nowYear = new Date().getFullYear()
              let nowMouth =
                new Date().getMonth() + 1 > 9
                  ? new Date().getMonth() + 1
                  : `0${new Date().getMonth() + 1}`
              let lastDay = new Date(nowYear, nowMouth, 0).getDate()

              //1232没开启默认当前月份的时间
              this.listQuery.EndTime = `${nowYear}-${nowMouth}-${lastDay}`
              this.listQuery.StartTime = `${nowYear}-${nowMouth}-01`
            }

            if (that.status1095 == '2' && that.listQuery.ZKJB == '1003') {
              this.isOpenMulti = true
            } else {
              this.isOpenMulti = that.status1095 == '1'
            }
            this.getJCBD()
          }
        }
      })
    },
    // 查询受检科室
    getZZjg() {
      GetZZjgByZkjbAndUser({
        UserId: this.UserInfo.UserId,
        Zkjb: 1003
      }).then((res) => {
        if (res.success) {
          this.filterQueryList[2].dataList = res.data.map((m) => {
            return {
              selectionCode: m.id,
              selectionName: m.name
            }
          })
          // this.listQuery.Jcfw = res.data[0].id
        }
      })
    },
    // 查询检查表单 - 后期需更换组件
    getJCBD() {
      this.listQuery.Bddms = ''
      GetJHJCBDList({
        OrgId: this.listQuery.Jcfw, // 根据检查部门做晒选
        Zkjb: this.listQuery.Zkjb,
        Zkzdm: '',
        Jcfs: '',
        Bdmc: '',
        isZHB: '',
        Bhty: true
      }).then((res) => {
        if (res.success) {
          this.filterQueryList[3].dataList = res.data
          this.GetZGList()
        }
      })
    },
    //获取整改列表数据
    GetZGList() {
      this.loading = true
      let obj = {
        PageIndex: this.listQuery.PageIndex,
        PageSize: this.listQuery.PageSize,
        Zkjb: this.listQuery.Zkjb,
        StartTime: this.listQuery.StartTime,
        EndTime: this.listQuery.EndTime,
        Bddms: this.listQuery.Bddms,
        Jcfw: this.listQuery.Jcfw,
        ZGZT: this.listQuery.ZGZT,
        XFWD: this.listQuery.XFWD,
        ZGLX: this.listQuery.ZGLX,
        isOnlyMe: this.isOnlyMe
      }
      const that = this
      if (!this.listQuery.Zkjb) {
        let zkjbList = this.filterQueryList[0].dataList
        let resultArr = new Array()

        if (zkjbList && zkjbList.length > 0) {
          for (var i = 0; i < zkjbList.length; i++) {
            resultArr.push(zkjbList[i].selectionCode)
          }
        }
        if (resultArr.length > 0) {
          this.listQuery.Zkjb = resultArr.join(',')
        }
      }
      if (this.listQuery.Zkjb) {
        this.$requestApi('GetZGList', obj)
          .then((res) => {
            if (res.success) {
              that.loading = false
              that.tableData = res.data
              that.listQuery.total = res.total
              that.$nextTick(() => {
                if (that.$refs.singleSelect) {
                  that.$refs.singleSelect.doLayout()
                }
                if (that.$refs.singleSelect.bodyWrapper) {
                  that.$refs.singleSelect.bodyWrapper.scrollTop = 0
                }
              })
              that.dataArr1 = toArray(res.data, that.tableColumns, 'key', true)
              that.rowSpanArr1 = that.getRowSpanForCondition(
                res.data,
                that.dataArr1,
                that.mergeColumn
              )
            }
          })
          .catch((error) => {
            that.loading = false
          })
      } else {
        that.loading = false
      }
    },
    // 切换tab
    changeType({ name }) {
      if (this.listQuery.XFWD == name) {
        return
      }
      this.listQuery.XFWD = name
      this.tableColumns = [...this.defaultColumns]
      // 3表单 4项目 5标准 6扣分标准
      // 切换时，需要把原来没有的列加入到默认显示中，不然会和缓存的列不一致，导致显示少了
      switch (name) {
        case '10': //扣分标准
          break
        case '20': //质量标准
          this.tableColumns.splice(7, 1) //"扣分标准"
          this.tableColumns.splice(5, 1) //"检查项目"
          break
        case '30': //项目
          this.tableColumns.splice(7, 1)
          this.tableColumns.splice(6, 1)
          break
        case '40': // 表单
          this.tableColumns.splice(7, 1)
          this.tableColumns.splice(6, 1)
          this.tableColumns.splice(5, 1)
          break
      }
      this.deal(name)
      this.handleAddNewList()
      this.GetZGList()
    },

    // 处理显示列
    deal(name) {
      let arr = [
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        }
      ]
      let num = Number(name)
      if (num < 20) {
        if (!this.showTableCheckList.some((m) => m.key == 'KFMC')) {
          this.showTableCheckList.splice(7, 0, arr[2])
        }
      }
      if (num < 30) {
        if (!this.showTableCheckList.some((m) => m.key == 'BZMC')) {
          this.showTableCheckList.splice(6, 0, arr[1])
        }
      }
      if (num < 40) {
        if (!this.showTableCheckList.some((m) => m.key == 'XMMC')) {
          this.showTableCheckList.splice(5, 0, arr[0])
        }
      }
    },
    // 批量整改
    mulZG() {
      if (this.selectObj.length == 0) {
        this.$msg('请选择数据!')
        return
      }
      if (this.selectObj.some((m) => m.SFDJ === 1)) {
        this.$msg('需要申请整改的数据不能进行批量整改!')
        return
      }
      if (this.selectObj.some((m) => m.ZGZT != 0 && m.ZGZT != 1)) {
        this.$msg('已整改的数据不能再进行整改!')
        return
      }

      let wtxhs = this.selectObj.map((m) => m.WTXH).join(',')
      // let plfxdmList = this.selectObj.map((m) => m.PLFXDM)
      // let fxxhList = this.selectObj.map((m) => m.FXXH)

      // let arrPLFXDM = [...new Set(plfxdmList)]
      // let arrFXXH = [...new Set(fxxhList)]
      // if (arrPLFXDM.length > 1 || arrFXXH.length > 1) {
      //   this.$msg('不能同时勾选两组数据进行整改!')
      //   return
      // }
      // let plfxdm = arrPLFXDM.join(',')
      // let fxxh = arrFXXH.join(',')

      let _sef = this
      let width = window.innerWidth * 0.7
      let height = window.innerHeight * 0.7
      this.$dlg.modal(QcRectificationDetail, {
        title: '整改评价',
        width: width,
        height: height,
        params: {
          wtxhs: wtxhs
        },
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {}
      })
    },
    printList() {
      let param = {
        UserId: this.UserInfo.UserId,
        PageIndex: this.listQuery.PageIndex,
        PageSize: this.listQuery.PageSize,
        Zkjb: this.listQuery.Zkjb,
        StartTime: this.listQuery.StartTime,
        EndTime: this.listQuery.EndTime,
        Bddms: this.listQuery.Bddms,
        Jcfw: this.listQuery.Jcfw,
        ZGLX: this.listQuery.ZGLX,
        ZGZT: this.listQuery.ZGZT,
        XFWD: this.listQuery.XFWD,
        isOnlyMe: this.isOnlyMe,
        ExportColumns: JSON.stringify(this.newTableList),
        FileType: 'PDF'
      }
      Print('NQCS/Print?act=ExportSJJCZG', param).then((res) => {
        let width = window.innerWidth
        let height = window.innerHeight
        const key = this.$dlg.modal(PdfDialog, {
          width: width,
          height: height,
          title: '文件打印',
          params: {
            pdfUrl: res.data.FilePath
          },
          callback: (data) => {
            if (this.isRefreshTable) {
              this.GetZGList()
            }
          },
          cancelCallback: () => {}
        })
      })
    },
    // 导出
    exportFile(type) {
      let obj = {
        UserId: this.UserInfo.UserId,
        PageIndex: this.listQuery.PageIndex,
        PageSize: this.listQuery.PageSize,
        Zkjb: this.listQuery.Zkjb,
        StartTime: this.listQuery.StartTime,
        EndTime: this.listQuery.EndTime,
        Bddms: this.listQuery.Bddms,
        Jcfw: this.listQuery.Jcfw,
        ZGZT: this.listQuery.ZGZT,
        XFWD: this.listQuery.XFWD,
        isOnlyMe: this.isOnlyMe,
        ExportColumns: JSON.stringify(this.newTableList),
        FileType: type // PDF/EXCEL
      }
      DownFile('NQCS/Download?act=ExportSJJCZG', obj)
    },
    // 跳转整改，自评页面
    toDetail(row, type) {
      let _sef = this
      let width = window.innerWidth * 0.7
      let height = window.innerHeight * 0.9
      let params = {
        wtxhs: row.WTXH || '',
        plfxdm: row.PLFXDM || '',
        fxxh: row.FXXH || '',
        type: type
      }
      this.$dlg.modal(QcRectificationDetail, {
        title: `${row.SFDJ === 1 ? '超期操作申请' : '整改评价'}`,
        width: width,
        height: height,
        params,
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {
          this.GetZGList()
        }
      })
    },
    // 跳转超期申请页面
    toSQ(row) {
      let _sef = this
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.6
      let zkjbTemp =
        row.ZKJB == 1001
          ? '三级质控'
          : row.ZKJB == 1002
          ? '二级质控'
          : '一级质控'
      let params = {
        dataList: this.applyData,
        row,
        sqnr: `【${zkjbTemp}】【${row.BDMC || ''}】 【${row.JCKSMC || ''}】 【${
          row.JCZ || ''
        }】 ${this.applyData.CJMC}操作`
      }

      this.$dlg.modal(ApplyDialog, {
        title: `超期操作申请`,
        width: width,
        height: height,
        params,
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {
          this.GetZGList()
        }
      })
    },
    rollBack(row) {
      let that = this
      this.$Confirm('是否撤销整改', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$requestApi('RollBackZG', {
            plfxdm: row.PLFXDM,
            fxxh: row.FXXH,
            wtxh: row.WTXH
          }).then((res) => {
            if (res.success) {
              that.$msg('撤销成功！', 'success')
              that.GetZGList()
            }
          })
        })
        .catch(() => {})
    },
    ignore(row) {
      let _sef = this
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.6
      let params = {
        WTXH: row.WTXH.toString()
      }
      this.$dlg.modal(IgnoreZG, {
        title: `忽略整改`,
        width: width,
        height: height,
        params,
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {}
      })
      // this.$Confirm('是否忽略整改', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then((res) => {
      //     this.$requestApi('IgnoreWT', {
      //       wtxhs: row.WTXH
      //     }).then((res) => {
      //       if (res.success) {
      //         that.$msg('忽略成功！', 'success')
      //         that.GetZGList()
      //       }
      //     })
      //   })
      //   .catch(() => {})
    },
    canCelIgnore(row) {
      let that = this
      this.$Confirm('是否撤销忽略', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$requestApi('CancelIgnoreWT', {
            wtxhs: row.WTXH
          }).then((res) => {
            if (res.success) {
              that.$msg('撤销成功！', 'success')
              that.GetZGList()
            }
          })
        })
        .catch(() => {})
    },
    print(wtxhs) {
      const param = {
        Wtxhs: wtxhs,
        FileType: 'PDF'
      }
      Print('NQCS/Print?act=ExportZGData', param).then((res) => {
        let width = window.innerWidth
        let height = window.innerHeight
        const key = this.$dlg.modal(PdfDialog, {
          width: width,
          height: height,
          title: '文件打印',
          params: {
            pdfUrl: res.data.FilePath
          },
          callback: (data) => {
            if (this.isRefreshTable) {
              this.GetZGList()
            }
          },
          cancelCallback: () => {}
        })
      })
    },
    getRowSpanForCondition(data, dataArr, conditions) {
      var rowSpanArr = [[]]
      let columns = dataArr[0].length || 0
      //用于记录每列的计算行
      let rowposition = Array(columns).fill(0)
      //循环每一行数据
      dataArr.forEach((item, row) => {
        //初始化每行每列
        rowSpanArr[row] = Array(columns).fill(1)
        if (row > 0) {
          let over = false //判断当前行是否重新开始合并
          //循环当前行的每一列
          for (let column = 0; column < dataArr[row].length; column++) {
            let flag = conditions.find((m) => {
              return m.colmunIndex == column
            })
            let isMerge = true
            if (flag) {
              //根据条件进行合并
              flag.condition.forEach((x) => {
                let current = data[row][x] || ''
                let last = data[row - 1][x] || ''
                // 当plfxdm为空时不要合并
                if (current != last || (data[row]['PLFXDM'] || '') == '') {
                  isMerge = false
                }
              })
            }
            // 只根据本列进行合并
            if (isMerge && dataArr[row][column] == dataArr[row - 1][column]) {
              if (over) {
                rowposition[column] = row
              } else {
                rowSpanArr[rowposition[column]][column] += 1
                rowSpanArr[row][column] = 0
              }
            } else {
              rowposition[column] = row
              over = true
            }
          }
        }
      })
      return rowSpanArr
    },
    mergeSpanMethod({ row, column, rowIndex, columnIndex }) {
      let mergeArr = this.mergeColumn.map((m) => {
        return m.colmunIndex
      })
      return this.objectSpanMethod(
        { row, column, rowIndex, columnIndex },
        this.rowSpanArr1,
        mergeArr
      )
    },
    objectSpanMethod(
      { row, column, rowIndex, columnIndex },
      rowSpanArr,
      columnArr
    ) {
      // 只合并区域位置
      row
      column
      //   console.log(row, column)
      if (columnArr.some((m) => m == columnIndex)) {
        const _row = rowSpanArr[rowIndex][columnIndex]
        return {
          rowspan: _row, //行
          colspan: 1 //列
        }
      }
      // 合并固定列有问题（注释）
      // else if (columnIndex == 16) {
      //   //操作列和第一列的选择框相同
      //   const _row = rowSpanArr[0][columnIndex]
      //   return {
      //     rowspan: _row, //行
      //     colspan: 1 //列
      //   }
      // }
    },
    showImg(row) {
      if (row && row.fileList && row.fileList.length > 0) {
        let width = window.innerWidth * 0.5
        let height = window.innerHeight * 0.7
        const key = this.$dlg.modal(imgView, {
          width: width,
          height: height,
          title: '附件预览',
          params: {
            fileList: row.fileList
          },
          callback: (data) => {},
          cancelCallback: () => {}
        })
      }
    },
    viewIgnoreFile(row, type) {
      let _sef = this
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.6
      let params = {
        WTXH: row.WTXH.toString(),
        readonly: true,
        type: type
      }

      let title = ''
      if (type == 'zg') {
        title = '整改附件详情'
      } else {
        title = '忽略整改'
      }

      this.$dlg.modal(IgnoreZG, {
        title: title,
        width: width,
        height: height,
        params,
        callback: (data) => {},
        cancelCallback: () => {}
      })
    },
    onDetail(row) {
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      const key = this.$dlg.modal(TaskDetailDialog, {
        width: width,
        height: height,
        title: '检查',
        params: { type: 'view', rowData: { ...row, type: 'view' } },
        callback: (data) => {
          if (data.success) {
            this.GetZGList()
          }
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.option-zoom {
  margin-top: 16px;
  text-align: right;
}
.option-zoom .w-button + .w-button {
  margin-left: 16px;
}
.table-container {
  background-color: white;
}
.tool-container {
  margin-top: 6px;
  margin-bottom: 6px;
}
.search-container {
  background-color: white;
  padding: 10px;
}
/deep/ .wn-table-template__funBtn {
  position: relative;
}
.tab-btn {
  position: absolute;
  right: 10px;
  top: -2px;
  z-index: 100;
}
/deep/ .w-dropdown-trigger svg {
  vertical-align: top;
}

/deep/ .w-dropdown-trigger svg.is-active path {
  d: path('M3.75 10.2002L7.99274 5.7998L12.2361 10.0425');
}

/deep/ .w-dropdown-trigger path {
  transition: d 0.2s;
  stroke: currentcolor;
}
/deep/ .w-dropdown-trigger {
  color: #2d5afa;
  font-size: 14px;
  cursor: pointer;
}
.table-inner-row {
  min-height: 40px;
  // line-height: 20px;
  padding: 0 2px;
  align-items: center;
  &:not(:last-child) {
    border-bottom: 1px solid #c9c9c9;
  }
  &-text {
    flex: auto;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    width: 100%;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    /*这里可以设置文本显示的行数*/
    overflow: hidden;
    vertical-align: middle;
  }
}
/deep/ .w-table .w-table__body-wrapper .cell,
/deep/ .w-table .w-table__fixed-body-wrapper .cell {
  padding: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  span {
    padding: 0 4px;
  }
}
/deep/ .tooltip-wrapper {
  padding: 0 4px;
}
</style>
